/**
 * Cart Toggle Action
 * Triggered by: arc:action:cartToggle
 * Opens the minicart/cart drawer or modal
 */

export const runCartToggle = async (data = {}) => {
  try {
    window.dispatchEvent(new CustomEvent('cart:toggle'));

    return {
      success: true,
      message: 'Cart toggled successfully'
    };
  } catch (error) {
    console.error('Error toggling cart:', error);

    // Dispatch error event
    window.dispatchEvent(
      new CustomEvent('cart:toggle_error', {
        detail: {
          error: error.message,
          type: data.type,
          section: data.section
        }
      })
    );

    return {
      success: false,
      error: error.message
    };
  }
};

export default runCartToggle;
